import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from '../environments/environment';

import * as atatus from 'atatus-spa';
atatus.config('8b637284de9543cb890b7a1b8fc118b9').install();

@Injectable()
class AtatusErrorHandler extends ErrorHandler {
	handleError(error: any): void {
		if (atatus && environment.production === true) {			
			atatus.notify(error.originalError || error);
		}

		console.error(error);
		throw error;
	}
}

export { AtatusErrorHandler };